export default{
  'overview_weekly_Weekly': 'Weekly',
  // 卡片标题和文字
  'overview_weekly_avgWAU': 'agv.WAU',
  'overview_weekly_WAU': 'WAU',

  'overview_weekly_W2(T-1)': 'W2(T-1)',


  'overview_weekly_W2/3': 'W2/3', // 18

  'overview_weekly_WAU_This_Week': 'WAU This Week', // 22
  'overview_weekly_WAU_Last_Month': 'WAU Last Month', // 23

  // 卡片
  'overview_weekly_key_performance_metrics_explain_au': 'Weekly Active Users.Number of users who have logged in to the game during the statistical period (vopenid deduplicated).Date more than 1 week shows averageWAU.',
  'overview_weekly_key_performance_metrics_explain_new': 'New Register Users.Total number of newly-registered users in the statistical period (vopenid deduplicated).Date more than 1 week shows sum new.',
  'overview_weekly_key_performance_metrics_explain_revenue': 'Count the total amount actually paid by the current players.Date more than 1 week shows sum revenue.',
  'overview_weekly_key_performance_metrics_explain_arpu': 'AverageRevenue Per Active Users.Consumption amount/Number of active users in the statistical period.<br/>Date more than 1 week shows average ARPU. Sum of consumption amount in the statistical period /Sum of active users in the statistical period.',
  'overview_weekly_key_performance_metrics_explain_payer': 'Number of paying users/Number of active users during the statistical period.<br/>Date more than 1 week shows average payer%.Sum of payers in the statistical period / Sum of active users in the statistical period.',
  'overview_weekly_key_performance_metrics_explain_w2': 'the retention rate of new register users on week 2 before the statistics week.<br/>W2：Number of retained users on week 2 from registration date / Number of new users on registration date.<br/>Registration week is week 1.<br/>Date more than 1 week shows average W2. Sum of retention users on week 2 in the statistical period / Sum of new register users in the statistical period.',

  // "b_Revenue($)": "Revenue($)", // 25
  "b_ARPPU($)": "ARPPU($)", // 26
  // "b_ARPU($)": "ARPU($)", // 27
  "b_Payer": "Payer", // 28
  // "b_Payer%": "Payer%", // 29
  'overview_weekly_Revenue($)_This_Week': 'Revenue($) This Week', // 30
  'overview_weekly_Revenue($)_Last_Month': 'Revenue($) Last Month', // 31

  // Overall Performance 宽表

  'overview_weekly_Avg.Daily_New': 'Avg.Daily New',
  'overview_weekly_Week_Avg.DAU': 'Week Avg.DAU',
  'overview_weekly_Week_Avg.Revenue($)': 'Week Avg.Revenue({unit})',

  'overview_weekly_avg_dau': 'Avg.DAU',
  'overview_weekly_W2': 'W2',
  'overview_weekly_W3': 'W3',
  'overview_weekly_W4': 'W4',

  'overview_weekly_WAU_Retention_Users': 'WAU Retention Users',

  'overview_weekly_WAU_Return_Users': 'WAU Return Users',
  'overview_weekly_Weighted_W2': 'Weighted W2',
  'overview_weekly_Weighted_W3': 'Weighted W3',
  'overview_weekly_Weighted_W2_short': 'WW2',
  'overview_weekly_Weighted_W3_short': 'WW3',
  'overview_weekly_Weighted_W4': 'Weighted W4',
  'overview_weekly_weighted_tab': 'Weighted W2/3',


  // WAU Breakdown 图表模块
  'overview_weekly_WAU_Breakdown': 'WAU Breakdown', // 1


  'overview_weekly_WAU_of_Top_10_Countries': 'WAU of Top 10 Countries', // 5
  'overview_weekly_Avg.WAU': 'Avg.WAU', // 6


  // 待补充
  'overview_week_retention_2': 'W2',
  'overview_week_retention_3': 'W3',
  'overview_week_Weighted_2': 'Weighted W2',
  'overview_week_Weighted_3': 'Weighted W3',
  'overview_weekly_Last_Week': 'Last Week',
  'overview_weekly_Today': 'Today',
  'overview_weekly_Last_Month': 'SWLM',
  'overview_weekly_This_Week': 'This Week',
  'overview_weekly_Last_Year': 'Last Year',
  'overview_weekly_This_Month': 'This Month',
  'overview_weekly_New': 'New',

}
